
<!--
  - Copyright (c) 2021 by Leyton Group - All Rights Reserved.
  -  This source code, and resulting software, is the confidential and proprietary information
  -  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
  -  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
  -  and shall use it only in accordance with the terms and conditions of any and all license
  -  agreements you have entered into with The Company.
  -->

<template>
  <div>
    <WorksList v-if="$route.name === 'Works'"/>
    <router-view v-else/>
  </div>
</template>

<script>

import WorksList from "@/views/Works/WorksList";

export default {
  name: "Works",
  components: {WorksList}
};
</script>


<style lang='scss'>
.view-area {
  position: relative;
  min-height: 560px;
  height: calc(100vh - 480px);
  padding-right: 1rem;
  margin-right: -1rem;
  overflow-y: auto;
}
.view-area-table {
  position: relative;
  min-height: 530px;
  height: calc(100vh - 530px);
  padding-right: 20px;
}
</style>
